import * as React from "react";

import { LockBlack } from "@livechat/design-system-icons";
import { Button, Icon } from "@livechat/design-system-react-components";

import { EmptyState } from "components/empty-state/EmptyState";
import Flex from "components/layout/Flex";

interface IProps {
  partnersContactEmail: string;
}

const PartnerSubscription: React.FC<IProps> = ({ partnersContactEmail }) => (
  <Flex alignItems="center" justifyContent="center" height="100%">
    <EmptyState title="Your subscription is handled by a Partner" icon={<Icon source={LockBlack} size="xxxlarge" />}>
      <Button
        kind="link-light"
        href={`mailto:${partnersContactEmail}`}
        target="_blank"
        rel="nofollow noreferrer noopener"
      >
        Ask your Partner
      </Button>{" "}
      for any changes to your HelpDesk subscription
    </EmptyState>
  </Flex>
);

export default PartnerSubscription;
